import React, { useState } from 'react';

export default function useModal() {
  const [isShowing, setIsShowing] = useState(false);
  const [innerHTML, setInnerHTML] = useState(<div>I am a modal!</div>);
  const [modalTitle, setModalTitle] = useState('Title Here');

  function toggle() {
    setIsShowing(!isShowing);
  }

  function setModalParams(modalDisplay, title) {
    setInnerHTML(modalDisplay);
    setModalTitle(title);
  }

  return {
    isShowing,
    innerHTML,
    modalTitle,
    toggle,
    setModalParams,
  };
}
